<template>
  <div
    v-if="hasRequestContentResponse && requestContentItem"
    class="flex flex-wrap items-center gap-2 dark:text-zinc-300 text-xs sm:text-sm"
    data-testid="request-content-info-component"
  >
    <div class="flex items-center gap-1.5">
      <Icon size="xs" name="general.chatAnswer" />
      <span class="font-semibold">Reply to:</span>
    </div>
    <div class="flex truncate items-center gap-2">
      <p data-testid="request-content-info-name" class="truncate">{{ requestContentItem.name }}</p>
      <a
        data-testid="request-content-info-link"
        class="text-blue-500"
        v-if="requestContentItem.requestLink"
        :href="requestContentItem.requestLink"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Request Link"
      >
        <Icon size="xs" name="general.externalLink" />
        <span class="sr-only">External link to the request</span>
      </a>
    </div>
    <template v-if="requestContentItem.customId">
      <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
      <p data-testid="request-content-info-custom-id" class="flex-shrink-0">Custom ID: {{ requestContentItem.customId }}</p>
    </template>
    <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
    <a class="text-blue-500 flex gap-1 items-center" :href="`/collections/${requestContentItem.collectionId}`" target="_blank" rel="noopener noreferrer">
      <Icon size="xs" name="general.turnDownRight" />
      Collection
    </a>
    <template v-if="insightsURL">
      <span class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
      <a
        class="text-blue-500 flex gap-1 items-center"
        data-testid="request-content-info-download-logs"
        :href="insightsURL"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon size="xs" name="general.downloadFile" />
        Download logs
      </a>
    </template>
    <span v-if="requestParamsToDisplay.length" class="flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light">|</span>
    <template v-for="param in requestParamsToDisplay" :key="param.key">
      <p class="property" :data-testid="`request-content-info-query-params-${param.key}`">{{ param.key }}: {{ param.value }}</p>
      <span class="divider">|</span>
    </template>

    <template v-if="requestContentParamsCount > REQUEST_PARAMS_TO_DISPLAY_COUNT">
      <button
        type="button"
        class="text-blue-500 flex gap-1 items-center"
        @click.stop="showRequestContentParamsModal"
        data-testid="request-content-info-query-params-more"
      >
        More
      </button>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { Icon } from '@/storybook';
import { onMounted } from 'vue';
import { useRequestContentInfoPage, REQUEST_PARAMS_TO_DISPLAY_COUNT } from '../composables/useRequestContentInfoPage';
import { useViewerItemStore } from '../store/useViewerItemStore';
import { useArtifactsStore } from '../store/useArtifactsStore';

const { loadData, showRequestContentParamsModal, requestContentItem, requestParamsToDisplay, requestContentParamsCount } = useRequestContentInfoPage();

const { hasRequestContentResponse } = useViewerItemStore();
const { insightsURL } = useArtifactsStore();

onMounted(() => {
  if (hasRequestContentResponse) {
    loadData();
  }
});
</script>

<style scoped>
.property {
  @apply flex-shrink-0 max-w-[30ch] truncate;
}
.divider {
  @apply flex-shrink-0 text-slate-300 dark:text-zinc-700 font-light;
}
</style>
